// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"450ce24e","74":"402113c4","203":"34759e3e","239":"ef7fe7b8","351":"88962ab0","453":"0f8e4aee","545":"e0048430","726":"c961ea61","732":"7290c1a9","804":"90b41c64","977":"017beeb8"}[chunkId] + ".chunk.js";
};